/**
 * The shop payment step's standard look (the Prints mockup's Payment section,
 * its Pay button and secure line), with the website's own card panel in place
 * of the mockup's drawn card fields (D4: where the mockup draws its own card
 * fields, the build uses the shared card panel). Draws the behavior half's
 * state and calls its actions.
 */
import { CardCheckoutPanel } from '@/components/payment/CardCheckoutPanel';

import { part } from '../../contract/runtime';
import shared from '../../styles/shared.module.css';
import { Icon } from '../../ui/Icon';
import type { ShopPaymentStepRuntime } from './useShopPaymentStep';
import css from './ShopPaymentStep.module.css';

export function ShopPaymentStepView({ state, actions, panel }: ShopPaymentStepRuntime) {
  return (
    <div className={css.step}>
      {state.notice ? (
        <p className={css.notice} role="status" {...part('notice')}>
          <Icon name="info" small />
          {state.notice}
        </p>
      ) : (
        <div {...part('card')}>
          <CardCheckoutPanel
            key={panel.key}
            ref={panel.ref}
            entry={panel.entry}
            intentRequest={panel.intentRequest}
            onCompleteChange={panel.onCompleteChange}
            onIntentReady={panel.onIntentReady}
            onSubmitInFlightChange={panel.onSubmitInFlightChange}
            onPaymentSubmitted={panel.onPaymentSubmitted}
            onDecline={panel.onDecline}
            onError={panel.onError}
            onConflict={panel.onConflict}
          />
        </div>
      )}
      <div className={css.submit}>
        {state.decline && (
          <p className={css.decline} role="alert" {...part('decline')}>
            <b>{state.decline}</b> {state.declineNote}
          </p>
        )}
        <button
          type="button"
          className={`${shared.btn} ${shared.btnPrimary} ${css.pay}`}
          disabled={Boolean(state.notice) || !state.complete || state.paying}
          onClick={actions.pay}
          {...part('pay')}
        >
          Pay {state.amount}
        </button>
        <p className={css.secure} {...part('secure')}>
          <Icon name="lock" small />
          {state.seller ? `Paid securely through Stripe. ${state.seller} is the seller.` : 'Paid securely through Stripe.'}
        </p>
      </div>
    </div>
  );
}
